<template>
  <svg
    width="14"
    height="17"
    viewBox="0 0 14 17"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.00479 13.2012C4.44604 13.2012 3.97222 13.0083 3.58333 12.6226C3.19444 12.2368 3 11.7646 3 11.206C3 10.6472 3.19285 10.1734 3.57854 9.78451C3.96437 9.39562 4.4366 9.20117 4.99521 9.20117C5.55396 9.20117 6.02778 9.39402 6.41667 9.77971C6.80556 10.1655 7 10.6378 7 11.1964C7 11.7551 6.80715 12.2289 6.42146 12.6178C6.03563 13.0067 5.5634 13.2012 5.00479 13.2012ZM1.5 16.7012C1.0875 16.7012 0.734375 16.5519 0.440625 16.2533C0.146875 15.9546 0 15.6039 0 15.2012V4.20117C0 3.79839 0.146875 3.4477 0.440625 3.14909C0.734375 2.85048 1.0875 2.70117 1.5 2.70117H3V0.701172H4.5V2.70117H9.5V0.701172H11V2.70117H12.5C12.9125 2.70117 13.2656 2.85048 13.5594 3.14909C13.8531 3.4477 14 3.79839 14 4.20117V15.2012C14 15.6039 13.8531 15.9546 13.5594 16.2533C13.2656 16.5519 12.9125 16.7012 12.5 16.7012H1.5ZM1.5 15.2012H12.5V7.70117H1.5V15.2012ZM1.5 6.20117H12.5V4.20117H1.5V6.20117Z"
    />
  </svg>
</template>
